<div class="message" [ngClass]="infoClass()" [class.first]="first===true" (click)="click()">
    <!-- info -->
    @switch (notification.type) {
        <!-- info -->
        @case(NotificationType.info) {
            <div class="ic"><i class="icon ico-info"></i></div>
        }

        <!-- warning -->
        @case(NotificationType.warning) {
            <div class="ic"><i class="icon ico-warning"></i></div>
        }

        <!-- error -->
        @case(NotificationType.error) {
            <div class="ic"><i class="icon ico-warning"></i></div>
        }

        <!-- fatal -->
        @case(NotificationType.fatal) {
            <div class="ic"><i class="icon ico-warning"></i></div>
        }

        <!-- help -->
        @case(NotificationType.help) {
            <div class="ic"><i class="icon ico-help"></i></div>
        }

        <!-- urgent-->
        @case(NotificationType.urgent) {
            <div class="ic"><i class="icon ico-warning"></i></div>
        }
    }

    <div class="txt" [innerHTML]="notification.message"></div>
</div>
